import { useEffect, useState } from "react";
import DateField from "../../components/shared/DateField";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import PageMain from "../../containers/shared/PageMain";
import apiClientFiles from "../../components/utils/apiClientFiles";
import moment from "moment";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import useUser from "../../components/helpers/useUser";
import apiClient from "../../components/utils/apiClient";
import Loading from "../../components/shared/Loading";
import { useNavigate } from "react-router-dom";
import SelectField from "../../components/shared/SelectField";
import Toast from "../../components/shared/Toast";
import { useTranslation } from "react-i18next";

const ReportsHomePage = () => {
    const { t, i18n } = useTranslation();
    const pageTitle = {title: t('reports.pageTitle')};
    useDocumentTitle(t('reports.pageTitle'));
    const [user,setUser] = useUser();
    const [vendor, setVendor] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [fileType, setFileType] = useState('pdf');
    const [isDownloadAllawed, setIsDownloadAllawed] = useState(false);
    const [toast, setToast] = useState({show: false,type: null, message:''});
    const navigate = useNavigate();

    const [showDownloadModal, setShowDownloadModal] = useState(false);


    const getUserData = async () => {
      try {
        const response = await apiClient.get(`vendors/${user?._id}`);
        if(response?.data) {
          setVendor(response?.data);
        } else {

        }
      } catch(err) {}
    }

    useEffect(()=>{
        if(user && user?._id) {
            getUserData();
        }
    },[user])


    const handleClickExportWorkersReport = async () => {
        setShowDownloadModal(t('reports.workersRequestsCountReport'));
        const startDatefinal = startDate ? moment(startDate).locale('en').format('YYYY/MM/DD') : null;
        const endDatefinal = endDate ? moment(endDate).locale('en').format('YYYY/MM/DD') : null;
        const file = fileType === 'pdf' ? 'pdf' : 'excel';
        const fileExt = fileType === 'pdf' ? 'pdf' : 'xlsx';
        try {
          const response = await apiClientFiles.get(`/vendor-reports/workers-requests-count?${startDatefinal && endDatefinal ? `dateFrom=${startDatefinal}&dateTo=${endDatefinal}` : ''}`);
          if(response.data) {
              const byteArray = new Uint8Array(response.data[file].buffer.data);
              const blob = new Blob([byteArray], { type: `application/${fileExt}` });
              let fileURL = URL.createObjectURL(blob);
              let fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.download = response.data[file].fileName || 'Fanni-Vendor-workers-report';
              fileLink.click();
          } else {
          }
          setShowDownloadModal(false);
        } catch(err) {
            setShowDownloadModal(false);
            if (err.response?.status === 404) {
                setToast({show:true,type:'error', message: t('reports.noRecordsFound')});
            } else {
                setToast({show:true,type:'error',message:err?.response?.data?.message});
            }
        }
    }
    

    const handleClickExportRequestsReport = async () => {
        setShowDownloadModal(t('reports.workersRequestsReport'));
        const startDatefinal = startDate ? moment(startDate).locale('en').format('YYYY/MM/DD') : null;
        const endDatefinal = endDate ? moment(endDate).locale('en').format('YYYY/MM/DD') : null;
        const file = fileType === 'pdf' ? 'pdf' : 'excel';
        const fileExt = fileType === 'pdf' ? 'pdf' : 'xlsx';
        try {
          const response = await apiClientFiles.get(`/vendor-reports/workers-requests?${startDatefinal && endDatefinal ? `dateFrom=${startDatefinal}&dateTo=${endDatefinal}` : ''}`);
          if(response.data) {
              const byteArray = new Uint8Array(response.data[file].buffer.data);
              const blob = new Blob([byteArray], { type: `application/${fileExt}` });
              let fileURL = URL.createObjectURL(blob);
              let fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.download = response.data[file].fileName || 'Fanni-Vendor-requests-report';
              fileLink.click();
          } else {
          }
          setShowDownloadModal(false);
        } catch(err) {
            setShowDownloadModal(false);
            if (err.response?.status === 404) {
                setToast({show:true,type:'error', message: t('reports.noRecordsFound')});
            } else {
                setToast({show:true,type:'error',message:err?.response?.data?.message});
            }
        }
    }


    useEffect(()=>{
        if(vendor && !vendor?.activeSubscription) {
            navigate(`/${i18n?.language || 'ar'}/settings/packages`);
        }
    },[vendor])

    useEffect(()=>{
        if(startDate && endDate && moment(startDate).isValid() && moment(endDate).isValid() && moment(startDate).isBefore(moment(endDate))) {
            setIsDownloadAllawed(true);
        } else {
            setIsDownloadAllawed(false);
        }
    },[startDate,endDate])

    const fileTypeOptions = [
        {value:'pdf', label:'PDF'},
        {value:'file', label:'xlsx'},
    ];



    return (
        <>
        {vendor &&<div>
                <PageHeader pageTitle={pageTitle} />
                <PageMain noPadding={true}>
                    <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
                    <MainContent>
                        <div className="mt-[-10px] mb-[5px] border-t-[3px] border-white lg:h-[56px] px-[16px]">
                            <div className="font-[500] text-grey-900 text-[16px] inline-block me-[10px] leading-[56px]">{t('reports.filterFrom')}</div>
                            <div className="inline-block">
                                <DateField maxToday selectView={true} value={startDate} error={''} errorMessage={''} translateError={true} onChange={(date)=>{ setStartDate(date)}} />
                            </div>
                            <div className="font-[500] text-grey-900 text-[16px] inline-block mx-[10px] leading-[56px]">{t('reports.filterTo')}</div>
                            <div className="inline-block">
                                <DateField maxToday selectView={true} value={endDate} error={''} errorMessage={''} translateError={true} onChange={(date)=>{ setEndDate(date)}} />
                            </div>
                            <div className="font-[500] text-grey-900 text-[16px] inline-block mx-[10px] leading-[56px]">{t('reports.fileType')}</div>
                            <div className="inline-block align-middle pt-[10px]">
                                <SelectField small isRequird label={t('reports.fileType')} options={fileTypeOptions} value={fileType} onChange={(e)=>setFileType(e.target.value)} />
                            </div>
                        </div>
                        <div className="bg-white py-[30px] px-[16px]">
                            <div className="flex flex-wrap lg:flex-nowrap justify-center gap-[20px]">
                                <div className="w-full lg:w-[50%] max-w-[372px] rounded-[8px] border-[1px] border-grey-300">
                                    <div className="h-[172px] w-full p-[15px]">
                                        <img src="/assets/images/reports-card-icon.svg" alt="" className="w-[64px] h-[64px]" />
                                        <p className="font-[600] text-[18px] text-darkBlue mt-[25px]">{t('reports.workersRequestsReport')}</p>
                                    </div>
                                    <div className={`h-[37px] w-full border-t-[1px] border-grey-300 cursor-pointer flex flex-nowrap select-none ${isDownloadAllawed ? '' : 'opacity-50 pointer-events-none'}`} onClick={()=>handleClickExportRequestsReport()}>
                                        <div className="w-[50%] text-start leading-[37px] px-[15px] text-blue font-[600] text-[14px]"><img src="/assets/images/import-icon.svg" alt="" className="inline-block w-[16px] h-[16px]" /> {t('reports.exportToFile')}</div>
                                        <div className="w-[50%] text-end py-[5px] px-[15px]"><img src="/assets/images/arrow-icon.svg" alt="" className="inline-block w-[16px] h-[16px] ltr:rotate-180" /></div>
                                    </div>
                                </div>
                                <div className="w-full lg:w-[50%] max-w-[372px] rounded-[8px] border-[1px] border-grey-300">
                                    <div className="h-[172px] w-full p-[15px]">
                                        <img src="/assets/images/reports-card-icon.svg" alt="" className="w-[64px] h-[64px]" />
                                        <p className="font-[600] text-[18px] text-darkBlue mt-[25px]">{t('reports.workersRequestsCountReport')}</p>
                                    </div>
                                    <div className={`h-[37px] w-full border-t-[1px] border-grey-300 cursor-pointer flex flex-nowrap select-none ${isDownloadAllawed ? '' : 'opacity-50 pointer-events-none'}`} onClick={()=>handleClickExportWorkersReport()}>
                                        <div className="w-[50%] text-start leading-[37px] px-[15px] text-blue font-[600] text-[14px]"><img src="/assets/images/import-icon.svg" alt="" className="inline-block w-[16px] h-[16px]" /> {t('reports.exportToFile')}</div>
                                        <div className="w-[50%] text-end py-[5px] px-[15px]"><img src="/assets/images/arrow-icon.svg" alt="" className="inline-block w-[16px] h-[16px] ltr:rotate-180" /></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        

                    </MainContent>
                </PageMain>
            <div className={`w-full max-w-[400px] h-[123px] fixed bottom-0 end-[25px] transform-gpu duration-300 transition-transform ${showDownloadModal ? 'translate-y-[0]' : 'translate-y-[123px]'}`}>
                <div className="w-full h-[51px] bg-grey-100 rounded-t-[8px] leading-[51px] font-[700] text-grey-900 text-[18px] relative px-[15px]">
                    {t('reports.preparingReport')}
                    <img src="/assets/images/close-download.svg" alt="" className=" absolute w-[24px] h-[24px] end-[15px] top-[13px] cursor-pointer" onClick={()=>setShowDownloadModal(false)} />
                </div>
                <div className="w-full h-[72px] bg-white px-[15px] py-[24px] font-[500] text-grey-900 text-[14px] relative">
                    <img src="/assets/images/document-download.svg" alt="" className="w-[20px] h-[20px] inline-block me-[3px]" />
                    {showDownloadModal}

                    <img src="/assets/images/download-loading.svg" alt="" className="animate-spin absolute w-[24px] h-[24px] top-[24px] end-[15px]" />
                </div>
            </div>
        </div>}

        <Toast toast={toast} setToast={setToast} />
        {!vendor && <Loading showLoading={true} />}
        </>
    )
}

export default ReportsHomePage;
